<script lang="ts">import { goto } from "$app/navigation";
import { buildBannerPathNew, isPromoExternalAbsoluteUrl, openPromoExternalInNewTab } from "../../utils";
import { stateUi } from "@infinitro/config";
import { locale, t, Verbiage } from "@infinitro/content";
import { isMobile, loggedIn, ModalDialog, pushModal, toSiteUrl, UI } from "@infinitro/global";
import PromoItemBannerContent from "./promo-item-banner-content.svelte";
import PromoCardFooterCustom from "./promo-item-footer-custom.svelte";
import PromoCardFooter from "./promo-item-footer.svelte";
export let promo;
export let active;
export let isNew;
export let isDetail;
export let custom = false;
$: useLoggedInPromoCta = $loggedIn === true || ($stateUi.promotions?.promoCtasMatchLoggedInWhenLoggedOut ?? false);
let isBigScreen = typeof window !== "undefined" && window.innerWidth >= 1500;
let imageUrl;
let imageFallbackUrl;
$: {
	imageUrl = $isMobile ? promo.banner : promo.bannerBig ?? promo.banner;
	imageFallbackUrl = $isMobile ? promo.banner : promo.bannerBig ?? promo.banner;
	let variant = "default";
	if (promo.onlyImage) {
		if (!useLoggedInPromoCta && isDetail && !promo.noSignUp) variant = "signup";
		else if (useLoggedInPromoCta && isDetail) variant = "action";
	}
	const loc = $locale !== "en" ? $locale : undefined;
	if (promo.autoBanner) {
		let mobile = buildBannerPathNew(promo, true, variant, loc);
		let desk = buildBannerPathNew(promo, false, variant, loc);
		imageUrl = $isMobile ? mobile.primary : isDetail ? desk.primaryBig : desk.primary;
		imageFallbackUrl = $isMobile ? mobile.fallback : desk.fallback;
	}
}
$: useAlternative = $stateUi.promotions.promotionsStyle === "alternative";
const clickSignUp = () => {
	pushModal(ModalDialog.Auth, { tab: "signup" });
};
const cashier = () => {
	pushModal(ModalDialog.Cashier);
};
const onlyImageAction = (e) => {
	e.preventDefault();
	e.stopPropagation();
	if (!active && !promo?.isFlushRace) return;
	if (useLoggedInPromoCta || promo.noSignUp) {
		if (promo.action && !(useAlternative && !isDetail) && !promo.noSignUp) {
			cashier();
		} else {
			const raw = promo.promotionUrl && isDetail ? promo.promotionUrl : promo.url;
			if (isPromoExternalAbsoluteUrl(raw)) {
				openPromoExternalInNewTab(raw);
			} else {
				goto(toSiteUrl(raw, useLoggedInPromoCta));
			}
		}
	} else if (useAlternative && !isDetail) {
		const raw = promo.promotionUrl ? promo.promotionUrl : promo.url;
		if (isPromoExternalAbsoluteUrl(raw)) {
			openPromoExternalInNewTab(raw);
		} else {
			goto(toSiteUrl(raw, useLoggedInPromoCta));
		}
	} else {
		clickSignUp();
	}
};
const bannerError = (fallback) => (e) => {
	if (fallback && e.currentTarget.src != fallback) {
		e.currentTarget.src = fallback;
	}
};
</script>

<div
	class="promo-item-card-container {custom ? 'promo-item-card-container-custom' : ''}"
	style={` ${isDetail ? 'padding: 0.5rem;' : 'cursor: pointer;'} `}
>
	<div
		class="banner-container {useAlternative ? 'variant-banner-container' : ''} {isDetail &&
		useAlternative
			? 'variant-banner-container-detail'
			: ''}"
		class:variant-banner-container-detail-alternative={isDetail}
		style={`border-radius: ${useAlternative ? '0' : '16px 16px 0 0'};`}
	>
		{#if promo.onlyImage}
			<button on:click={onlyImageAction}>
				<img
					src={imageUrl}
					alt={$t(Verbiage.banner_alt, 'alts')}
					class="banner {useAlternative ? 'variant-banner' : ''}"
					on:error={(e) => {
						const fallback = imageFallbackUrl;
						bannerError(fallback)(e);
					}}
				/>
			</button>
		{:else}
			<img
				src={imageUrl}
				alt={$t(Verbiage.banner_alt, 'alts')}
				class="banner {useAlternative ? 'variant-banner' : ''}"
				on:error={(e) => {
					const fallback = imageFallbackUrl;
					bannerError(fallback)(e);
				}}
			/>
		{/if}

		{#if !useAlternative}
			<PromoItemBannerContent {promo} {isDetail} />
		{/if}
	</div>
	{#if custom}
		<PromoCardFooterCustom {promo} {active} {isNew} {isDetail} {isBigScreen} />
	{:else}
		<PromoCardFooter {promo} {active} {isDetail} {isBigScreen} />
	{/if}
</div>

<style>
	.promo-item-card-container {
		position: absolute;
		top: 0px;
		left: 0px;
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
}

	.promo-item-card-container-custom {
		justify-content: space-between;
		padding: 2%;
}

	.banner-container {
		position: relative;
		display: flex;
		width: 100%;
		justify-content: center;
		aspect-ratio: 361 / 226;
}

	@media (min-width: 1024px) {
		.banner-container {
			aspect-ratio: 329 / 212;
		}
	}

	.banner-container::after {
		position: absolute;
		bottom: 0px;
		left: 0px;
		height: 30%;
		width: 100%;
		content: '';
		box-shadow: inset 0px -8px 8px -6px rgba(0, 0, 0, 0.7);
		z-index: 10;
}
	.banner-detail {
		min-width: 100%;
}

	@media (min-width: 1024px) {
		.banner-detail {
			aspect-ratio: 900 / 226;
		}
	}

	.banner-detail-content {
		position: absolute;
		top: 1rem;
		left: 1rem;
}

	.detail-banner-container {
		position: relative;
}

	.variant-banner-container {
		aspect-ratio: 2.7 / 1;
	}

	@media (min-width: 1024px) {

		.variant-banner-container-detail {
				aspect-ratio: 5/1;
		}

		.variant-banner-container-detail-alternative {
				aspect-ratio: 4/1;
		}
}

	.variant-banner-container::after {
		display: none;
}

	.banner {
		position: absolute;
		top: 0px;
		left: 0px;
		min-height: 100%;
		width: 100%;
		border-top-left-radius: var(--border-radius-promo-item);
		border-top-right-radius: var(--border-radius-promo-item);
		-o-object-fit: fill;
		   object-fit: fill;
		-o-object-position: right center;
		   object-position: right center;
		z-index: 5;
}

	@media (min-width: 1024px) {
		.banner {
			-o-object-fit: cover;
			   object-fit: cover;
		}
	}

	.variant-banner {
		border-radius: 0px;
}

	@media (min-width: 1024px) {
		.variant-banner {
				max-width: 100%;
		}
	}

	.banner-picture {
		opacity: 0;
		transition: opacity 0.3s ease;
	}

	.banner-picture.loaded {
		opacity: 1;
	}
</style>
